// eslint-disable-next-line rulesdir/display-name-property
const getQrCodeDownloadFileName = (title) => `${title}-ShareCode.png`;

export default getQrCodeDownloadFileName;
